export enum UrlParams {
	State = 'state',
	Region = 'region',
	Town = 'town',
	Hotel = 'hotel',
}
